<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <v-avatar
                :color="getAppBarColor"
                size="80"
              >
                <span
                  class="white--text"
                  style="font-size: 25pt"
                >
                  {{ getUser.nome.charAt(0) }}
                </span>
              </v-avatar>
            </div>
            <div class="text-center mt-2">
              <h3 class="grey--text text--darken-2">{{ getUser.nome }}</h3>
              <h4 class="grey--text">{{ getUser.apelido }}</h4>
              <h4 class="grey--text">{{ getUser.email }}</h4>
              <h4 class="grey--text">{{ getUser.telefone }}</h4>
              <h4 class="grey--text">{{ getUser.papel }}</h4>
              <v-divider class="mt-2"></v-divider>
            </div>
            <div class="text-center mt-5">
              <v-btn
                color="teal"
                dark
                tile
                class="ml-1 mt-1"
                style="width: 200px"
                @click="$refs.dialogAtualizarDados.show()"
              >
                <v-icon left>mdi-account-circle</v-icon>
                Atualizar dados
              </v-btn>

              <v-btn
                color="grey darken-1"
                dark
                tile
                class="ml-1 mt-1"
                style="width: 200px"
                @click="$refs.dialogAlterarSenha.show()"
              >
                <v-icon left>mdi-lock</v-icon>
                Alterar senha
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <DialogAlterarSenha ref="dialogAlterarSenha" />
    <DialogAtualizarDados ref="dialogAtualizarDados" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    DialogAlterarSenha: () => import('./DialogAlterarSenha'),
    DialogAtualizarDados: () => import('./DialogAtualizarDados')
  },

  computed: {
    ...mapGetters('auth', ['getUser']),
    ...mapGetters('app', ['getAppBarColor'])
  }
}
</script>
